<div class="date-picker-wrapper" [formGroup]="form">
  <p class="label" *ngIf="label">{{label}}</p>
  <div
    class="input-date-container"
    [attr.opened]="dateMenu.menuOpen ? '1' :'0'"
    [matMenuTriggerFor]="menu"
    #dateMenu="matMenuTrigger"
    (click)="onSelectDate(dateMenu)"
    [attr.language]="language"
  >
    <!-- <mat-icon>date_range</mat-icon> -->
    <app-svg-icon [icon]="IconsConstants.CALENDAR_ICON"></app-svg-icon>
    <input
      [disabled]="this.form.disabled"
      [placeholder]="isSingleDaySelect ? ('PLACEHOLDERS.SELECT_DATE' | translate) : ('PLACEHOLDERS.SELECT_DATE_RANGE' | translate)"
      class="date-input ellipsis"
      type="text"
      readonly
      [value]="inputValue"
    />

    <!-- start mat menu -->
    <mat-menu #menu="matMenu" (closed)="onCloseMenu()">
      <div class="date-container" (click)="$event.stopPropagation()">
        <div class="custom-header">
          <button mat-icon-button (click)="onHeaderButtonClicked('month' , language == 'ar' ? 'next' : 'prev')">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <span class="header-label">{{periodLabel | dateFormatter : SharedConstants.FULL_MONTH_YEAR_DATE_FORMAT : language }}</span>
          <button mat-icon-button (click)="onHeaderButtonClicked('month' , language == 'ar' ? 'prev' : 'next')">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        </div>
        <!-- start ranges list -->
        <ul class="ranges" *ngIf="!isSingleDaySelect">
          <ng-container
            *ngFor="let range of (DateRanges | enumToArray : [DateRanges.TODAY , DateRanges.YESTERDAY , DateRanges.LAST_WEEK , DateRanges.LAST_MONTH])"
          >
            <li [attr.active]="selectedRangeLabel == range.value ? 'active':''" (click)="onSelectDateRange(range)" class="range-item">
              {{"ENUMS.DATE_RANGES." + range.key | translate}}
            </li>
          </ng-container>
        </ul>
        <!-- end ranges list -->
        <!-- start date picker -->
        <div class="date-picker">
          <mat-calendar
            #calendar
            [maxDate]="maxDate"
            [minDate]="minDate"
            (selectedChange)="onChangeSelectedDateRange($event)"
            (monthSelected)="onSelectMonthOrYear($event)"
            (yearSelected)="onSelectMonthOrYear($event)"
            [selected]="selectedDateRange"
          ></mat-calendar>
        </div>
        <!-- end date picker -->
        <!-- ------------------------------------ -->
      </div>
    </mat-menu>
  </div>
  <!-- error message Validator  -->
  <app-error-validation-message [control]="formControl" [errors]="formControl.errors"></app-error-validation-message>
</div>
